import type { WidgetCandidatesKind, WidgetCandidatesState } from '@recruitee/dashboard-types';
import type { PickActions } from '@recruitee/ngrx';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';

const {
  actions,
  reducer: CandidatesWidgetReducer,
  selectors: CandidatesWidgetSelectors,
  namespace: CandidatesWidgetNamespace,
} = createEntityCollectionStore<WidgetCandidatesState>()('CandidatesWidget', {
  customActions: adapter => {
    const actions = getEntityCollectionActions(adapter, ({ id }) => id);

    return {
      fetchOne: (state, payload: { id: WidgetCandidatesKind; departmentIds: number[] }) =>
        actions.fetchOne(state, payload),
    };
  },
});

const CandidatesWidgetActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  CandidatesWidgetActions,
  CandidatesWidgetReducer,
  CandidatesWidgetSelectors,
  CandidatesWidgetNamespace,
};
